import script from "./RubinFirstLook.vue?vue&type=script&setup=true&lang=ts"
export * from "./RubinFirstLook.vue?vue&type=script&setup=true&lang=ts"

import "./RubinFirstLook.vue?vue&type=style&index=0&id=16d895e9&lang=less"

const __exports__ = script;

export default __exports__